import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { BatchListItemVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const retrieveEducationalAdvisorBatches = createAsyncThunk<BatchListItemVM[], void, { extra: Partial<Dependencies> }>(
  "educationalAdvisor/retrieveBatches",
  async (_, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.batchList();
  },
);
